import {CommandBase} from "./CommandBase";
import {Asset} from "../entities/Asset";
import {CommandManager} from "../libs/CommandManager";

export class CommandGetAlarmsCtrl extends CommandBase{
    selectedItems:any[];
    commandEnabled:boolean = false;
    static $inject = ['CommandManager'];
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    getCommandText(asset:Asset):string{
        return asset.vTagID;
    }
    getCommandType():string{
        return "Get Alarms";
    }
}

export class CommandGetAlarmsDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdgetalarms.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandGetAlarmsCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.selectedItems.length, (newVal:any)=> {
            controller.selectedItems = scope.selectedItems;
        });
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandGetAlarmsDirective();
        }
        return directive;
    }
}
